export enum PaymentRange {
  TODAY = 'today',
  YESTERDAY = 'yesterday',
  DAYS_7 = 'days_7',
  DAYS_30 = 'days_30',
  DAYS_90 = 'days_90',
}
